import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {buildListWithLength} from '../../../utils';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'mwo-slot-time-picker',
  templateUrl: './slot-time-picker.component.html',
  styleUrls: ['./slot-time-picker.component.scss']
})
export class SlotTimePickerComponent implements OnInit {
  hours: number[] = buildListWithLength(24);
  minutes: number[] = buildListWithLength(60);

  availableBeginningHours: number[] = this.hours;
  availableBeginningMinutes: number[] = this.minutes;
  availableEndHours: number[] = this.hours;
  availableEndMinutes: number[] = this.minutes;

  @Input()
  slotBeginningHour: number;
  @Input()
  slotBeginningMinute: number;
  @Input()
  slotEndHour: number;
  @Input()
  slotEndMinute: number;

  slotTimePickerForm: FormGroup;

  @Output()
  onTimePickerChange = new EventEmitter<any>();

  constructor(private formBuilder: FormBuilder) {
  }

  ngOnInit(): void {
    this.slotTimePickerForm = this.formBuilder.group({
      beginningHour: [this.slotBeginningHour, Validators.required],
      beginningMinute: [this.slotBeginningMinute, Validators.required],
      endHour: [this.slotEndHour, Validators.required],
      endMinute: [this.slotEndMinute, Validators.required]
    });

    if (this.slotBeginningHour == this.slotEndHour) {
      this.availableBeginningMinutes = this.minutes.slice(0, this.slotEndMinute);
      this.availableEndMinutes = this.minutes.slice(this.slotBeginningMinute + 1);
    } else {
      this.availableBeginningHours = this.hours.slice(0, this.slotEndHour + 1);
      this.availableEndHours = this.hours.slice(this.slotBeginningHour);
    }
  }

  onBeginningHourSelected(): void {
    this.availableEndHours = this.hours.slice(this.slotTimePickerForm.get('beginningHour').value);
    if (this.slotTimePickerForm.get('endHour').value < this.slotTimePickerForm.get('beginningHour').value) {
      this.slotTimePickerForm.controls['endHour'].setValue(this.slotTimePickerForm.get('beginningHour').value);
    }
    if (this.slotTimePickerForm.get('beginningHour').value == this.slotTimePickerForm.get('endHour').value) {
      if (this.slotTimePickerForm.get('endMinute').value != 0) {
        if (this.slotTimePickerForm.get('beginningMinute').value >= this.slotTimePickerForm.get('endMinute').value) {
          this.slotTimePickerForm.controls['beginningMinute'].setValue(this.slotTimePickerForm.get('endMinute').value - 1);
        }
        this.availableBeginningMinutes = this.minutes.slice(0, this.slotTimePickerForm.get('endMinute').value);
      } else {
        this.slotTimePickerForm.controls['beginningHour'].setValue(this.slotTimePickerForm.controls['endHour'].value - 1);
        this.slotTimePickerForm.controls['beginningMinute'].setValue(59);
        this.availableBeginningMinutes = this.minutes;
      }
    }
    //this.consoleLogs();
    this.onTimePickerChanged();
  }

  onBeginningMinuteSelected(): void {
    if (this.slotTimePickerForm.get('beginningHour').value === this.slotTimePickerForm.get('endHour').value) {
      this.availableEndMinutes = this.minutes.filter(minute => minute > this.slotTimePickerForm.get('beginningMinute').value);
      this.slotTimePickerForm.controls['endMinute'].setValue(this.slotTimePickerForm.get('beginningMinute').value + 1);
    } else {
      this.availableEndMinutes = this.minutes;
    }
    //this.consoleLogs();
    this.onTimePickerChanged();
  }

  onEndHourSelected(): void {
    this.availableBeginningHours = this.hours.slice(0, this.slotTimePickerForm.get('endHour').value + 1);
    if (this.slotTimePickerForm.get('beginningHour').value != this.slotTimePickerForm.get('endHour').value) {
      this.availableBeginningMinutes = this.minutes;
      this.availableEndMinutes = this.minutes;
    } else {
      if (this.slotTimePickerForm.get('beginningMinute').value != 59) {
        // The end minute must be greater than the start minute. For exemple you first choose 6:25 -> 13:14 then you switch 13 to 6 so it's now 6:25 -> 6:14 -> IMPOSSIBLE !
        if (this.slotTimePickerForm.get('endMinute').value <= this.slotTimePickerForm.get('beginningMinute').value) {
          this.slotTimePickerForm.controls['endMinute'].setValue(this.slotTimePickerForm.get('beginningMinute').value + 1);
        }
        this.availableEndMinutes = this.minutes.slice(this.slotTimePickerForm.get('beginningMinute').value + 1);
      }
        // BUT not if the beginning minute is 59 ! Special case
      //Here, in the case of the exemple in the comment above, the behavior will be -> if it's 6:59, then we put end hour to beginning + 1 and end minute to 0
      else {
        this.slotTimePickerForm.controls['endHour'].setValue(this.slotTimePickerForm.controls['beginningHour'].value + 1);
        this.slotTimePickerForm.controls['endMinute'].setValue(0);
        this.availableEndMinutes = this.minutes;
      }
    }
    //this.consoleLogs();
    this.onTimePickerChanged();
  }

  onEndMinuteSelected(): void {
    this.availableBeginningMinutes = this.slotTimePickerForm.get('beginningHour').value === this.slotTimePickerForm.get('endHour').value
      ? this.minutes.filter(minute => minute < this.slotTimePickerForm.get('endMinute').value)
      : this.minutes;
    //this.consoleLogs();
    this.onTimePickerChanged();
  }

  onTimePickerChanged(): void {
    this.onTimePickerChange.emit(this.slotTimePickerForm.value);
  }

  /*
  consoleLogs() {
    console.log('Heure début: ', this.slotTimePickerForm.get('beginningHour').value);
    console.log('Minute début: ', this.slotTimePickerForm.get('beginningMinute').value);
    console.log('Heure fin: ', this.slotTimePickerForm.get('endHour').value);
    console.log('Minute fin: ', this.slotTimePickerForm.get('endMinute').value);
  }*/
}
